import TContentBox from "./TContentBox";

export default TContentBox;
